import React from 'react';
import CookieConsent, { getCookieConsentValue, Cookies } from "react-cookie-consent";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {

    // internationalization
    const { t, i18n } = useTranslation();

    const handleAccept = () => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }
    };

    const handleDecline = () => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('consent', 'update', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            });
        }
    };

return (
        <CookieConsent
            location="bottom"
            buttonText={t("cookie-banner.accept")}
            declineButtonText={t("cookie-banner.decline")}
            enableDeclineButton
            onAccept={handleAccept}
            onDecline={handleDecline}
            cookieName="habp_cookie_consent"
            style={{ background: "#21252B", alignItems: "center", fontSize: "1em"}}
            buttonStyle={{ color: "#ffffff", fontSize: "1em", borderRadius: "4px", backgroundColor: "#67B9FF", textShadow: "1px 1px 0 #969494" }}
            declineButtonStyle={{ background: "transparent", border: "1px solid white", color: "white", fontSize: "1em", borderRadius: "4px" }}
            expires={365}
        >
            {t("cookie-banner.text")}
            <Link to="/cookies" style={{ color: "#fff", textDecoration: "underline" }}>
                {t("cookie-banner.link")}
            </Link>.
        </CookieConsent>
    );
};

export default CookieBanner;
